import type { Token } from "@/domains/core"

import { useChainConfig } from "./use-chain-config"

export const useGovernanceToken = () => {
  const chainConfig = useChainConfig()

  return chainConfig.tokens.governance as Token
}
